import { BarChart } from "@mantine/charts";
import { useMantineTheme } from "@mantine/core";
import "./WelderStatusBarChart.css";

export type WelderStatusBarChartProps = {
  data: { status: string; value: number }[];
  orientation?: "vertical" | "horizontal";
};

export function WelderStatusBarChart({ data, orientation = "vertical" }: WelderStatusBarChartProps) {
  const theme = useMantineTheme();

  // Map data to have a 'Count' property for the series
  const chartData = data.map((d) => ({ status: d.status, Count: d.value }));

  return (
    <div className="welder-status-bar-chart-wrapper" style={{ flex: 1, display: "flex", flexDirection: "column" }}>
      <BarChart
        h="100%"
        mih={160}
        data={chartData}
        dataKey="status"
        series={[{ name: "Count", color: "#0088ff" }]}
        withLegend={false}
        withTooltip={false}
        orientation={orientation}
        gridAxis="none"
        yAxisProps={{ width: 80 }}
        barProps={{ label: { position: "right" } }}
      />
    </div>
  );
}
